import { render } from "./ModalHeader.vue?vue&type=template&id=acb60f6e&ts=true"
import script from "./ModalHeader.vue?vue&type=script&lang=ts"
export * from "./ModalHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__